import { API_BASE_URL } from '../config';
export interface PriceItem {
    symbol: string;
    date: string;
    price: number;
  }
  
  export const fetchPrice = async (symbol:string, from: any = null, to: any = null): Promise<PriceItem[]> => {
    var API_URL = `${API_BASE_URL}/price?symbol=${symbol}`; // Replace with your real endpoint
    if(from && to) {
      API_URL += `&from=${from}&to=${to}`;
    }
    console.log('API URL:', API_URL); // Log the API URL for debugging
    try {
      const response = await fetch(API_URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
  
      if (!response.ok) {
        throw new Error(`API error: ${response.statusText}`);
      }
  
      const responseData = await response.json();
      var data = responseData.data;
      console.log('Response data:', data); // Log the response data for debugging
      return responseData.data as PriceItem[]; // Adjust based on actual response format
    } catch (error) {
      console.error('Error fetching price:', error);
      throw error;
    }
  };